module.exports = __webpack_public_path__ + "static/pivas_bgc-425286df0c8c510f549ee726b93188c5.jpg";